// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__3sYcZ","spin":"Spinner_spin__3inKZ"};